import { Directive, DirectiveBinding } from "vue";

// 自适应表格高度
interface ExHTMLElement extends HTMLElement {
  resizeListener: EventListener;
}
// 初始设置表格高度
const setTableHeight = (el: ExHTMLElement, binding: DirectiveBinding) => {
  const top = getElementTop(el);
  const bottom = binding.value && typeof binding.value.bottom !== "undefined" ? binding.value.bottom : 80;
  const pageHeight = window.innerHeight;
  el.style.height = `${pageHeight - top - bottom}px`;
  el.style.overflowY = "auto";
};

// 获取元素距离顶部高度
const getElementTop = (element: ExHTMLElement) => {
  if (element.getBoundingClientRect) {
    return element.getBoundingClientRect().top;
  } else {
    let top = element.offsetTop;
    let current = element.offsetParent;
    while (current) {
      top += (current as ExHTMLElement).offsetTop + current.clientTop;
      current = (current as ExHTMLElement).offsetParent;
    }
    return top;
  }
};

const resizeDirective: Directive<ExHTMLElement> = {
  mounted(el, binding) {
    el.resizeListener = () => {
      requestAnimationFrame(() => {
        setTableHeight(el, binding);
      });
    };

    setTableHeight(el, binding);
    // 监听窗口大小变化事件
    window.addEventListener("resize", el.resizeListener);
  },
  unmounted(el) {
    window.removeEventListener("resize", el.resizeListener);
  },
  updated(el, binding) {
    // 确保更新后重新设置表格高度
    requestAnimationFrame(() => {
      setTableHeight(el, binding);
    });
  },
};

export default resizeDirective;
